import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core'
import { TablesWidgetIPLogs } from '../../../_metronic/partials/widgets/_new/tables/TablesWidgetIPLogs'

const IPList: FC = () => {
  return (
    <>
      <div className='row'>
        <div className='col-lg-12'>
          <TablesWidgetIPLogs className='card-xxl-stretch mb-5 mb-xl-10' />
        </div>
      </div>
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const IPListWrapper: FC = () => {
  const intl = useIntl()
  const { setRightTolbar } = useLayout()

  useEffect(() => {
    setRightTolbar('iplist')
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>{intl.formatMessage({ id: 'PAGE.IP_LIST', defaultMessage: 'PE-TM Details' })}</PageTitle>
      <IPList />
    </>
  )
}

export { IPListWrapper }
